<form [formGroup]="model.asForm" (ngSubmit)="enviar()" autocomplete="off">
    <div class="row">
        <div class="col-12">
            <div>
                <div class="form-group mb-2">
                    <label for="valorContraProposta">Nova proposta</label>
                    <input currencyMask type="text" class="form-control" id="valorContraProposta"
                        aria-describedby="valorContraProposta" placeholder="Ex: R$12.548,39"
                        formControlName="valorContraProposta">
                    <div class="invalid-feedback-inputs"
                        *ngIf="!validarFormulario && model.asForm.controls.valorContraProposta.invalid">
                        <span>Campo obrigatório</span>
                    </div>
                </div>
                <div class="form-group mb-4">
                    <app-input-text-area
                        [label]="'Observações'"
                        [id]="'observacaoParceiro'"
                        [rows]="7"
                        [required]="false"
                        [maxlength]="LIMITES_CARACTERES.OBSERVACAO"
                        [invalid]="!validarFormulario && model.asForm.controls.observacaoParceiro.invalid"
                        [msgAlerta]="'Limite máximo de caracteres: ' + limiteMaxCaracteres"
                        formControlName="observacaoParceiro"></app-input-text-area>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="row">
    <div class="col-6">
        <button class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()">Cancelar</button>
    </div>
    <div class="col-6">
        <button (click)="enviar()" class="btn btn-primary float-end btn-sm w-100">Ok</button>
    </div>
</div>
